"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalShading = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
class LocalShading extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.LOCAL_SHADING,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS],
            cost: 4,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: '235',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 Floater to this card.', (eb) => {
                        eb.empty().startAction.floaters(1);
                    }).br;
                    b.or().br;
                    b.action('Spend 1 Floater here to raise your M€ production 1 step.', (eb) => {
                        eb.floaters(1).startAction.production((pb) => pb.megacredits(1));
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        if (this.resourceCount < 1) {
            player.addResourceTo(this, 1);
            return undefined;
        }
        const opts = [];
        const addResource = new SelectOption_1.SelectOption('Add 1 floater to this card', 'Add floater', () => this.addResource(player));
        const spendResource = new SelectOption_1.SelectOption('Remove 1 floater to increase M€ production 1 step', 'Remove floater', () => this.spendResource(player));
        opts.push(spendResource);
        opts.push(addResource);
        return new OrOptions_1.OrOptions(...opts);
    }
    addResource(player) {
        player.addResourceTo(this, 1);
        return undefined;
    }
    spendResource(player) {
        player.removeResourceFrom(this);
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        return undefined;
    }
}
exports.LocalShading = LocalShading;
//# sourceMappingURL=LocalShading.js.map